import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { SelectContainer } from '../styles';

export const SumResultsContainer = styled.div`
    ${BaseStyle.Mixins.gaps.extraSmall};
    align-items: center;
    display: flex;
    justify-content: end;

    input {
        height: 12px;

        &:checked {
            accent-color: ${({ theme }) => theme.Surface.Opposite.primary};
        }
    }
`;

export const SeasonRangeContainer = styled(SelectContainer)`
    grid-column: 1 / 3;
`;
